<script setup lang="ts">
import { useCityStore } from '@/store/city/city'
import { useToggleStore } from '@/store/toggle/toggle'

import { HttpStatusCode, NotFoundError, ServerError } from '@/api/results'
import { NAME_PARENT_COMPONENT } from '@/types/products'

import ProductItem from '@/components/Product/ProductItem/ProductItem.vue'

const route = useRoute()
const { $apiService } = useNuxtApp()

const {
  cityInfo: { domain },
} = useCityStore()

const { data: productInfo, error } = await useAsyncData(async () => {
  const result = await $apiService.category.fetchOneProduct(
    String(route.params.product),
  )

  if (result instanceof NotFoundError) {
    throw createError({
      statusCode: HttpStatusCode.NOT_FOUND,
    })
  }

  if (result instanceof ServerError) {
    throw createError({
      statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
    })
  }

  return result.data
})

if (error.value) showError(error.value)

const { isLandingPageEnabled } = useToggleStore()

const productBreadcrumbs = computed(() => {
  if (!isLandingPageEnabled) return productInfo.value?.breadcrumbs

  return productInfo.value?.breadcrumbs?.filter((breadcrumb) => {
    return breadcrumb.href !== productInfo.value?.category.path
  })
})

usePopupFetch()
</script>

<template>
  <div class="base-container">
    <div v-if="productInfo" class="page__content">
      <app-head
        :title="productInfo?.seo?.seo_title"
        :seo="{
          title: productInfo?.seo?.seo_title,
          keywords: productInfo?.seo?.seo_keywords,
          description: productInfo?.seo?.seo_description,
        }"
      />

      <the-breadcrumbs
        v-if="productBreadcrumbs"
        :breadcrumbs="productBreadcrumbs"
        :domain="domain"
      />

      <product-item
        :product="productInfo"
        :parent-component="NAME_PARENT_COMPONENT.PAGE"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base-container {
  padding: 30px calc((100% - 1200px) / 2) 100px;
  @include media('>=portrait-phone', '<=desktop') {
    padding-right: 48px;
    padding-left: 48px;
  }

  @include media('<=portrait-phone') {
    padding-right: 20px;
    padding-left: 20px;
  }
}
</style>
